import { Component, computed, inject, input, output } from "@angular/core";
import { TranslocoService, TranslocoPipe } from "@jsverse/transloco";
import { ConversionService } from "src/app/shared/services/conversion.service";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { FormatDatePipe } from "@pipes/format-date.pipe";
import { TranslocoDecimalPipe } from "@jsverse/transloco-locale";
import { TinyObject } from "src/app/shared/contract/Address/tiny-object";

export interface LookupObjectViewModel {
  TypeTranslationKey: string;
  LivingSpace: number;
  Floor: string;
  Unit: string;
  isCache: boolean;
  creationDateTime: Date;
  customerId: string;
  displayText?: string;
}
@Component({
  selector: "app-tiny-object-list",
  templateUrl: "./tiny-object-list.component.html",
  styleUrl: "./tiny-object-list.component.scss",
  imports: [MatIcon, MatTooltip, TranslocoPipe, FormatDatePipe, TranslocoDecimalPipe]
})
export class TinyObjectListComponent {
  translocoService = inject(TranslocoService);
  conversionService = inject(ConversionService);

  objects = input<TinyObject[]>([]);
  createNewTitleTranslationKey = input<string>("");
  createEnabled = input(true);

  objectSelected = output<TinyObject>();
  createNewObjectClicked = output<void>();

  viewModel = computed(() => {
    const objects = this.objects();

    if (!objects || objects.length === 0) {
      return [];
    }

    let viewModel: (LookupObjectViewModel & { originalObject: TinyObject })[] = [];

    objects.forEach(obj => {
      const propertyTypeTranslationKey = `Properties.ObjectType.LongVersion.${this.conversionService.convertObjectSubTypeToObjectType(Number(obj.TinyObjectInformation.Type))}`;

      viewModel.push({
        TypeTranslationKey: propertyTypeTranslationKey,
        LivingSpace: obj.TinyObjectInformation.LivingSpace,
        Floor: obj.TinyObjectInformation.Floor,
        Unit: obj.TinyObjectInformation.Unit,
        originalObject: obj,
        isCache: obj.FromAccumateCache,
        creationDateTime: obj.CreationDateTime ? new Date(obj.CreationDateTime) : null,
        customerId: obj.CustomerId,
        displayText: obj.DisplayText
      });

      viewModel = viewModel.sort((a, b) => {
        if (a.isCache === b.isCache) return 0;
        return a.isCache ? -1 : 1;
      });
    });

    return viewModel.sort((a, b) => {
      if (a.isCache === b.isCache) return 0;
      return a.isCache ? -1 : 1;
    });
  });

  selectObject(obj: TinyObject) {
    this.objectSelected.emit(obj);
  }
}
